/* Il file caricato è una lista di TIM o di CERVED (13/10/2026).

   Quelle liste hanno colonne tutte loro e una prova tutta loro — il numero troncato da una
   parte, la partita IVA dall'altra — e non si mappano colonna per colonna: non c'è un numero
   da mettere in archivio, c'è un'azienda da ritrovare. Quindi la mappatura si salta e si
   chiede una cosa sola: le mando in «Da qualificare»? */
import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../config';
import { IconSpinner } from '../Icons';

/* Cosa sa fare l'app con questa lista, detto a chi l'ha caricata. Puro: provato a parte. */
export function spiegaLista(tipo) {
  if (tipo === 'cerved') {
    return {
      titolo: 'Lista CERVED',
      cosa: 'In questa lista il numero del cliente non c’è: ci sono la partita IVA e i dati '
        + 'dell’azienda. L’agente cerca l’azienda e conferma il numero trovato con la partita '
        + 'IVA scritta sul suo sito.',
    };
  }
  return {
    titolo: 'Lista TIM',
    cosa: 'In questa lista il numero è troncato (per esempio 098425***): non si può chiamare, '
      + 'ma le cifre visibili sono la prova. L’agente cerca l’azienda e tiene il numero solo '
      + 'se comincia con quelle cifre.',
  };
}

export default function StepListaAttesa({ dati, uploadId, nomeFile, onFatto, onIndietro }) {
  const [invio, setInvio] = useState(false);
  const [errore, setErrore] = useState(null);
  const { titolo, cosa } = spiegaLista(dati.tipo);
  const n = (x) => (x || 0).toLocaleString('it-IT');

  async function manda() {
    setErrore(null);
    setInvio(true);
    try {
      const r = await axios.post(`${API}/import/in-attesa`, { upload_id: uploadId });
      onFatto(r.data);
    } catch (e) {
      setErrore(e?.response?.data?.detail || 'Non sono riuscito a caricare la lista');
      setInvio(false);
    }
  }

  return (
    <div className="card">
      <h2 style={{ marginBottom: 4 }}>{titolo} riconosciuta</h2>
      <p style={{ color: 'var(--muted)', fontSize: 13.5, marginTop: 0 }}>
        Ho riconosciuto <strong>{nomeFile}</strong> dalle sue colonne: non è una lista di numeri
        da importare, è una lista di aziende da ritrovare. Va in <strong>Da qualificare</strong>,
        non in archivio.
      </p>
      <p style={{ fontSize: 13.5, marginTop: 0 }}>{cosa}</p>

      <div className="kpi-grid" style={{ marginTop: 16 }}>
        <div className="kpi" style={{ borderLeftColor: '#06b6d4' }}>
          <div className="label">{dati.leggibili === 1 ? 'Riga da qualificare' : 'Righe da qualificare'}</div>
          <div className="value" style={{ color: '#0891b2' }}>{n(dati.leggibili)}</div>
        </div>
        {dati.saltate > 0 && (
          <div className="kpi" style={{ borderLeftColor: '#f59e0b' }}>
            <div className="label">{dati.saltate === 1 ? 'Riga illeggibile' : 'Righe illeggibili'}</div>
            <div className="value" style={{ color: '#d97706' }}>{n(dati.saltate)}</div>
          </div>
        )}
      </div>
      {dati.saltate > 0 && (
        <p style={{ fontSize: 13, color: 'var(--muted)', marginTop: 10 }}>
          {n(dati.saltate)} {dati.saltate === 1 ? 'riga non ha' : 'righe non hanno'} nulla con cui lavorare
          {dati.tipo === 'cerved'
            ? ' (senza nome o senza partita IVA valida)'
            : ' (senza nemmeno una cifra visibile del numero)'}
          {dati.saltate === 1 ? ' e non viene caricata.' : ' e non vengono caricate.'}
        </p>
      )}

      {(dati.anteprima || []).length > 0 && (
        <div style={{ overflowX: 'auto', marginTop: 12 }}>
          <table className="tabella">
            <thead>
              <tr>
                <th>Ragione sociale</th>
                <th>Comune</th>
                <th>{dati.tipo === 'cerved' ? 'Partita IVA' : 'Numero nella lista'}</th>
              </tr>
            </thead>
            <tbody>
              {dati.anteprima.map((r, i) => (
                <tr key={i}>
                  <td>{r.ragione_sociale || '—'}</td>
                  <td>{r.comune || '—'}</td>
                  <td>{(dati.tipo === 'cerved' ? r.partita_iva : r.numero) || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {errore && (
        <div style={{ marginTop: 14, padding: '12px 16px', background: '#fef2f2',
                      border: '1px solid var(--err)', borderRadius: 8,
                      color: 'var(--err)', fontSize: 13 }}>
          {errore}
        </div>
      )}

      <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
        <button className="btn" onClick={onIndietro} disabled={invio}>Cambia file</button>
        <button className="btn btn-primary" onClick={manda} disabled={invio}>
          {invio ? <IconSpinner size={16} /> : null}
          {invio ? ' Carico…' : `Metti in Da qualificare (${n(dati.leggibili)} ${dati.leggibili === 1 ? 'riga' : 'righe'})`}
        </button>
      </div>
    </div>
  );
}
